/**
 * Facade — re-exports from split composables for backward compatibility.
 * New consumers should import directly from:
 *   - credit-limit/use-credit-limit-pill.ts   (CMS path: pill, banner, cart)
 *   - credit-limit/use-credit-limit-settings.ts (Ankorpay path: settings page)
 *   - credit-limit/credit-limit-state.ts       (enums, constants, helpers)
 */
export {
  CreditLimitState,
  CreditLimitCmsStatus,
  ACTIVE_STATUSES,
  PROCESSING_STATUSES,
  ARIA_PSP_NAME,
} from './credit-limit/credit-limit-state';

export { useCreditLimitPill, clearPillState } from './credit-limit/use-credit-limit-pill';
export { useCreditLimitSettings, clearSettingsState } from './credit-limit/use-credit-limit-settings';

import { useCreditLimitPill, clearPillState } from './credit-limit/use-credit-limit-pill';
import { useCreditLimitSettings, clearSettingsState } from './credit-limit/use-credit-limit-settings';

export function clearCreditLimitCache(): void {
  clearPillState();
  clearSettingsState();
}

/** @deprecated Use useCreditLimitPill or useCreditLimitSettings directly */
export function useCreditLimit() {
  const pill = useCreditLimitPill();
  const settings = useCreditLimitSettings();

  return {
    // State
    isLoading: pill.isLoading,
    status: settings.status,
    state: settings.state,
    isActive: settings.isActive,
    isProcessing: settings.isProcessing,
    isRefused: settings.isRefused,
    isFrozen: settings.isFrozen,
    // Amounts
    availableAmount: pill.availableAmount,
    formattedAvailableAmount: pill.formattedAvailableAmount,
    ariaAvailableAmount: settings.ariaAvailableAmount,
    formattedAriaAvailableAmount: settings.formattedAriaAvailableAmount,
    formattedUnpaidAmount: pill.formattedUnpaidAmount,
    // Navbar pill
    showCreditLimitPill: pill.showCreditLimitPill,
    creditLimitIncomplete: pill.creditLimitIncomplete,
    creditLimitFrozen: pill.creditLimitFrozen,
    creditLimitRefused: pill.creditLimitRefused,
    creditLimitKycRequired: pill.creditLimitKycRequired,
    creditLimitKycInReview: pill.creditLimitKycInReview,
    isLegalInformationProtectedRefusal: pill.isLegalInformationProtectedRefusal,
    frozenReason: pill.frozenReason,
    isFrozenReasonLoading: pill.isFrozenReasonLoading,
    hasMultipleProviders: pill.hasMultipleProviders,
    activeProviderCount: pill.activeProviderCount,
    // CMS denied access
    isDeniedCreditAccess: pill.isDeniedCreditAccess,
    // PSP
    pspName: pill.pspName,
    isAriaPsp: pill.isAriaPsp,
    cmsStatus: pill.cmsStatus,
    // Aria eligibility
    hasDebtorId: settings.hasDebtorId,
    // Mandate data
    debtorId: settings.debtorId,
    kycLink: settings.kycLink,
    ariaProviderStatus: settings.ariaProviderStatus,
    ibanLast4: settings.ibanLast4,
    signatureDate: settings.signatureDate,
    // Actions
    setCreditLimitFromCms: pill.setCreditLimitFromCms,
    fetchCreditLimit: pill.fetchCreditLimit,
    fetchAriaCreditLimit: settings.fetchAriaCreditLimit,
    refreshFromCms: pill.refreshFromCms,
  };
}
